<div>
  <div class="rs-modal-close">
    <button class="rs-link-action rs-link-action-close close-reveal-modal" (click)="close()">
      <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
        ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
      >
    </button>
  </div>
  <div class="rs-modal-heading">
    <p *ngIf="option.ibStatus === 'AVA'">
      {{ 'payAndGo.modal.aboutto.order' | translate }}
    </p>
    <p *ngIf="option.ibStatus === 'ACT'">
      {{ 'payAndGo.modal.aboutto.cease' | translate }}
    </p>
    <h2 class="rs-modal-heading-title" id="modal_label">{{ option.name }}</h2>
  </div>
  <div class="rs-modal-content">
    <div class="rs-form-item">
      <div class="rs-checkbox">
        <input
          id="at-checkbox"
          class="e2e-checkbox-termsAndConditions"
          type="checkbox"
          [(ngModel)]="acceptTermsAndConditions"
          required
        />
        <label for="at-checkbox">
          <span [innerHTML]="'payAndGo.modal.termsandconditions' | translate"></span>
        </label>
      </div>
    </div>
  </div>
  <div class="rs-padding-bottom2">
    <button
      class="rs-btn rs-btn-order"
      [ngClass]="{ 'rs-btn-disabled': !acceptTermsAndConditions }"
      (click)="confirm()"
    >
      <span *ngIf="option.ibStatus === 'AVA'">{{ 'payAndGo.modal.activate' | translate }}</span>
      <span *ngIf="option.ibStatus === 'ACT'">{{ 'payAndGo.modal.remove' | translate }}</span>
    </button>
  </div>
</div>
